import { motion } from "framer-motion"
import { ArrowRight, Sparkles } from "lucide-react"
import { Button } from "@/components/ui/button"
import { PaperDemo } from "@/components/common/PaperDemo"

export function Hero() {
  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <section className="relative overflow-hidden bg-canvas">
      <div className="max-w-5xl mx-auto px-4 sm:px-8 pt-32 pb-24 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* 文案 */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-info-soft text-info-foreground text-caption mb-8">
            <Sparkles className="w-3.5 h-3.5" />
            错什么，练什么
          </div>

          <h1 className="text-display text-ink mb-6">
            错一道，
            <br />
            <span className="text-primary">会一道</span>
          </h1>

          <p className="text-body text-ink-soft max-w-md mb-10">
            拍照传错题，小智帮你找出错因，再出题练到会。错题不只是收着，还要练会。
          </p>

          <div className="flex flex-col sm:flex-row gap-4 items-start">
            <Button size="lg" onClick={() => scrollToSection("platforms")}>
              免费开始
              <ArrowRight className="w-4 h-4" />
            </Button>
            <Button
              size="lg"
              variant="ghost"
              onClick={() => scrollToSection("loop")}
            >
              看看闭环怎么转
            </Button>
          </div>

          <p className="text-caption text-ink-soft mt-6">
            免费额度即可体验完整闭环 · 微信小程序 / Web 同步
          </p>
        </motion.div>

        {/* 签名视觉：草稿纸 + 小智批注 */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="max-w-md w-full mx-auto lg:mx-0 lg:justify-self-end"
        >
          <PaperDemo />
        </motion.div>
      </div>
    </section>
  )
}
